module.exports = __webpack_public_path__ + "img/ARE.ad288310.svg";